import React, { PureComponent } from 'react';
import { Overlay, Mask } from '@instructure/ui-overlays';
import { Spinner } from '@instructure/ui-spinner';



// This is taken right from sample code on instructure.design
export class SavingModal extends PureComponent {
  state = {
    open: true,
  };

  _mask = null;
  mask = () => this._mask;

  gotMaskRef = elem => {
    this._mask = elem;
  };

  render () {
    const t = window._t;

    return (
      <Overlay
        open={this.state.open}
        transition="fade"
        label={t("Please hang on…")}
        shouldContainFocus
        onDismiss={noop}
        defaultFocusElement={this.mask} >
        <Mask
          onClick={noop}
          elementRef={this.gotMaskRef} >
          <Spinner
            renderTitle={t("Submitting your assessment.")}
            size="large"
            margin="auto" />
        </Mask>
      </Overlay>
    );
  }

}



const noop = () => {};
